import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { firestore } from '../config/firebaseConfig';
import { doc, getDoc, updateDoc, collection, getDocs } from 'firebase/firestore';
import './CursoDetails.css';

function CursoDetails() {
  const { id } = useParams(); // Obtendo o parâmetro da URL
  const [curso, setCurso] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [cursosDisponiveis, setCursosDisponiveis] = useState([]); // Lista de cursos disponíveis para pré-requisito
  const [searchTerm, setSearchTerm] = useState(''); // Termo de pesquisa para filtrar cursos
  const [filteredCursos, setFilteredCursos] = useState([]); // Cursos filtrados com base no termo de pesquisa

  useEffect(() => {
    const fetchCurso = async () => {
      try {
        const docRef = doc(firestore, 'cursos', id); // Referência ao documento específico
        const docSnap = await getDoc(docRef); // Obtendo o documento
        if (docSnap.exists()) {
          setCurso({ id: docSnap.id, ...docSnap.data() }); // Armazenando os dados do curso
          setFormData({ ...docSnap.data() }); // Configurando os dados do formulário
        } else {
          console.log('No such document!');
          setCurso(null); // Definir curso como null se não encontrado
        }
      } catch (error) {
        console.error('Erro ao buscar curso:', error);
      } finally {
        setLoading(false); // Indicando que o carregamento foi concluído
      }
    };

    const fetchCursosDisponiveis = async () => {
      try {
        const cursosRef = collection(firestore, 'cursos');
        const cursosSnap = await getDocs(cursosRef);
        const cursosList = cursosSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCursosDisponiveis(cursosList);
        setFilteredCursos(cursosList); // Inicialmente, mostrar todos os cursos disponíveis
      } catch (error) {
        console.error('Erro ao buscar cursos disponíveis:', error);
      }
    };

    fetchCurso(); // Chamada da função para buscar o curso ao montar o componente
    fetchCursosDisponiveis(); // Chamada da função para buscar cursos disponíveis
  }, [id]); // Executando sempre que o parâmetro 'id' da URL mudar

  const handleEditToggle = () => {
    setIsEditing(!isEditing); // Alternando o modo de edição
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'valorInvest' ? parseFloat(value) : value // Atualizando os dados do formulário
    });
  };

  const handleSelectChange = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      preRequi: value // Atualizando o pré-requisito selecionado
    });
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchTerm(value);
    // Filtrar cursos com base no termo de pesquisa
    const filtered = cursosDisponiveis.filter(curso => 
      curso.nomeCurso.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCursos(filtered);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(firestore, 'cursos', id); // Referência ao documento específico
      const updatedData = {
        ...formData,
        dataAtual: new Date(), // Atualizando o campo dataAtual
      };

      await updateDoc(docRef, updatedData); // Atualizando o documento no Firestore
      setCurso({ ...curso, ...updatedData }); // Atualizando os dados do curso exibido
      setIsEditing(false); // Saindo do modo de edição
    } catch (error) {
      console.error('Erro ao atualizar curso:', error);
    }
  };

  const calculateCompletionPercentage = () => {
    const totalFields = Object.keys(formData).length;
    const filledFields = Object.values(formData).filter(value => value || value === 0).length;
    return Math.round((filledFields / totalFields) * 100); // Calculando a porcentagem de preenchimento do formulário
  };

  if (loading) return <p>Carregando...</p>; // Exibindo mensagem de carregamento enquanto os dados são obtidos

  const completionPercentage = calculateCompletionPercentage(); // Calculando a porcentagem de preenchimento

  return (
    <div className="curso-details">
      {curso ? (
        <>
          {isEditing ? (
            <form onSubmit={handleFormSubmit}>
              <h1>Editar Curso</h1>
              <label>
                Nome do Curso:
                <input
                  type="text"
                  name="nomeCurso"
                  value={formData.nomeCurso || ''}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Área:
                <input
                  type="text"
                  name="area"
                  value={formData.area || ''}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Descrição:
                <textarea
                  name="descricao"
                  value={formData.descricao || ''}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Carga Horária:
                <input
                  type="text"
                  name="cargaHr"
                  value={formData.cargaHr || ''}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Modalidade:
                <input
                  type="text"
                  name="modalidade"
                  value={formData.modalidade || ''}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Turma:
                <input
                  type="text"
                  name="turma"
                  value={formData.turma || ''}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                URL do Programa:
                <input
                  type="text"
                  name="programaUrl"
                  value={formData.programaUrl || ''}
                  onChange={handleInputChange}
                />
              </label>
              
              <label>
                Pré-requisito:
                <select
                  name="preRequi"
                  value={formData.preRequi || ''}
                  onChange={handleSelectChange}
                >
                  <option value="">Nenhum</option>
                  {filteredCursos.map(curso => (
                    <option key={curso.id} value={curso.id}>
                      {curso.nomeCurso}
                    </option>
                  ))}
                </select>
              </label>
              
              <label>
                Valor de Investimento:
                <input
                  type="number"
                  step="0.01" // Permite valores com casas decimais
                  name="valorInvest"
                  value={formData.valorInvest || ''}
                  onChange={handleInputChange}
                />
              </label>
              <button type="submit">Salvar</button>
              <button type="button" onClick={handleEditToggle}>Cancelar</button>
            </form>
          ) : (
            <>
              <h1>{curso.nomeCurso}</h1>
              <div className="completion-bar">
                <div className="completion-bar-filled" style={{ width: `${completionPercentage}%` }}>
                  {completionPercentage}%
                </div>
              </div>
              <p><strong>Área:</strong> {curso.area}</p>
              <p><strong>Descrição:</strong> {curso.descricao}</p>
              <p><strong>Carga Horária:</strong> {curso.cargaHr}</p>
              <p><strong>Modalidade:</strong> {curso.modalidade}</p>
              <p><strong>Turma:</strong> {curso.turma}</p>
              <p><strong>URL do Programa:</strong> {curso.programaUrl}</p>
              <p><strong>Pré-requisito:</strong> {curso.preRequi ? cursosDisponiveis.find(c => c.id === curso.preRequi)?.nomeCurso : 'Nenhum'}</p>
              
              <p><strong>Valor de Investimento:</strong> {curso.valorInvest}</p>
              <button onClick={handleEditToggle}>Editar</button>
            </>
            
          )}
        </>
      ) : (
        <p>Curso não encontrado.</p>
      )}
    </div>
  );
}

export default CursoDetails;
